import axios from 'axios';
import { BASE_URL } from '@/global/util/constants';
import Page from '@/global/util/Page';

const AD_USER_PAGE_HEADER = {
  id: '广告主ID',
  name: '广告名称',
  industry_id: '行业类型',
  web_site: '网站URL',
  created_at: '创建时间',
  permission: '权限'
};

const state = {
  page: new Page(),
  roles: [],
  permissions: [],
  others: [],
  adUsers: [],
  adUserPage: new Page()
};

const getters = {
  page: state => state.page,
  roles: state => state.roles,
  permissions: state => state.permissions,
  others: state => state.others,
  adUsers: state => state.adUsers,
  adUserPage: state => state.adUserPage
};

const mutations = {
  SET_ROLES(state, data) {
    state.roles = data;
  },
  SET_PERMISSION(state, data) {
    state.permissions = data.menu;
    state.others = data.other;
  },
  SET_USERS(state, data) {
    state.adUsers = data;
  }
};

const actions = {
  async getStaffList({ state, commit }, { request = axios.get, params } = {}) {
    const data = await request(`${BASE_URL}/general/staff`, params);
    state.page.setPageData({
      ...data.data,
      list: data.data.list.map(item => ({ ...item, visible: false }))
    }, false);
  },
  async addStaff({ state, commit }, { request = axios.post, params } = {}) {
    const data = await request(`${BASE_URL}/general/staff`, params);
    return data;
  },
  removeStaff({ state, commit }, { request = axios.delete, id } = {}) {
    const data = request(`${BASE_URL}/general/staff/${id}`);
    return data;
  },
  updateStaff({ state, commit }, { request = axios.patch, id, params } = {}) {
    const data = request(`${BASE_URL}/general/staff/${id}`, params);
    return data;
  },
  async findStaff({ state, commit }, { request = axios.get, plat, id } = {}) {
    const { data } = await request(`${BASE_URL}/general/staff/${id}`);
    if (plat === 'agency') {
      const headers = Object.keys(AD_USER_PAGE_HEADER);
      const pageData = data.aders.map(v => {
        let item = {};
        for (let key in v) {
          if (headers.indexOf(key) > -1) {
            item[key] = v[key];
          }
        }
        item.permission = [];
        if (data.data_p.length === 1 && data.data_p[0] === 'all') {
          item.permission.push('2');
        } else if (
          data.data_p.length > 0 &&
          data.data_p.indexOf(`${v.id}`) > -1
        ) {
          item.permission.push('2');
        }

        if (data.operate_p.length === 1 && data.operate_p[0] === 'all') {
          item.permission.push('1');
        } else if (
          data.operate_p.length > 0 &&
          data.operate_p.indexOf(`${v.id}`) > -1
        ) {
          item.permission.push('1');
        }

        return item;
      });

      state.adUserPage.setPageData(
        {
          header: AD_USER_PAGE_HEADER,
          data: pageData,
          total: pageData.length
        },
        false
      );
    }
    return data;
  },
  async getRoleTypes({ state, commit }, { request = axios.get, params } = {}) {
    const { data } = await request(`${BASE_URL}/general/staff/role_type`);
    commit('SET_ROLES', data);
    return data
  },
  async getPermissions(
    { state, commit },
    { request = axios.get, params } = {}
  ) {
    const data = await request(`${BASE_URL}/general/staff/perm`, params);
    commit('SET_PERMISSION', data.data);
  },
  async getAdUsers({ state, commit }, { request = axios.get, params } = {}) {
    const data = await request(`${BASE_URL}/general/staff/aderOption`, params);
    commit('SET_USERS', data.data);
  },
  async getAdUser({ state, commit }, { request = axios.get, id } = {}) {
    const data = await request(`${BASE_URL}/general/staff/aderInfo/${id}`);
    state.adUserPage.setPageData(
      {
        header: AD_USER_PAGE_HEADER,
        data: [
          ...state.adUserPage.data,
          {
            ...data.data,
            permission: ['1', '2']
          }
        ],
        total: state.adUserPage.total + 1
      },
      false
    );
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
